import state from "@/state";
import clsx from "clsx";
import HeroImage from "components/HeroImage";
import { isImageDark } from "lib/helpers";
import React, { useEffect } from "react";

const Hero = ({ image, imageMobile, heading, text }) => {
  useEffect(() => {
    if (!image) return;

    const asyncIsImageDark = async (src) => isImageDark(src);

    asyncIsImageDark(image.url).then((isDark) => {
      state.header.theme = isDark ? "light" : "dark";
    });

    return () => {
      state.header.theme = "dark";
    };
  }, [image]);

  return (
    <div
      className={clsx(
        "Hero",
        "w-full h-[33.333vh] lg:h-[66.666vh] lg:min-h-[680px] lg:max-h-[890px]"
      )}
    >
      <div className={clsx("w-full h-full bg-black")}>
        <HeroImage
          image={image}
          imageMobile={imageMobile}
          heading={heading}
          text={text}
        />
      </div>
    </div>
  );
};

export default Hero;
